import React, {Component} from 'react';
import '../../../chat.css';
import ChatQuestionTypeEnum from "../../../config/constants/ChatQuestionTypeEnum";
import Icon from "@material-ui/core/Icon";
import AttachmentICon from '@material-ui/icons/Attachment';
import Setup from "../../../config/Setup";
import axios from 'axios';
import Localization from "../../../config/localization/Localization";
import MoodICon from "@material-ui/icons/Mood";
import {getLocalizationLanguageCode} from "../../../util/localization";

/**
 * Class for the chat message input menu.
 */
class ChatAttachment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null,
            file: null,
            loadedFile: null,
            progress: null,
            hover: false,
            maxSize: 270532608,
            loading: false,
            uploadIsHovered : false,
            pendingFiles: []
        }
    }

    handleUploadHover=()=>{
        this.setState({
            uploadIsHovered: !this.state.uploadIsHovered
        });
    }

    openMenu = () => {
        this.setState({anchorEl: this.btnEl});
    }

    closeMenu = () => {
        this.setState({anchorEl: null});
    };

    sendIntent = (chatMenuItem) => {
        this.props.sendIntent(chatMenuItem.intentId, ChatQuestionTypeEnum.menuItem,
            chatMenuItem.displayName, null, null, chatMenuItem.id);

        this.closeMenu();
    };

    componentDidUpdate(prevProps) {
        if (
            prevProps.fileUploadedListRemove !== this.props.fileUploadedListRemove &&
            this.props.fileUploadedListRemove !== null
        ) {
            this.setState(prevState => ({
                pendingFiles: prevState.pendingFiles.filter((_, i) => i !== this.props.fileUploadedListRemove)
            }), () => {
            this.props.handleFlushDeleteUploadedFile(); 
            })}
        }



    handleCapture = ({ target }) => {
        const localizationCode = getLocalizationLanguageCode(this.props.language ? this.props.language.languageCode : null);
        const files = Array.from(target.files); // Konverter FileList til array
        let newPendingFiles = [...this.state.pendingFiles];

        // Check if limit of 5 files is reached
        if (newPendingFiles.length + files.length > 5) {
            this.props.setSnackbarErrorMessage(Localization[localizationCode]['chatInput.chatAttachment.maxFilesError'] || "You can only upload up to 5 files.");
            return;
        }

        files.forEach(file => {
            if (file.size > Setup.uploadFileSizeLimit) {
                this.props.setSnackbarErrorMessage(Localization[localizationCode]['chatInput.chatAttachment.fileSizeError']);
                return;
            }

            if (newPendingFiles.some(existingFile => existingFile.name === file.name && existingFile.size === file.size)) {
                this.props.setSnackbarErrorMessage(Localization[localizationCode]['chatInput.chatAttachment.sameFileError']);
                return;
            }

            const fileReader = new FileReader();
            this.setState({ progress: 0, loading: true });

            fileReader.onabort = () => console.log('File reading was aborted');
            fileReader.onerror = () => console.log('File reading has failed');

            fileReader.onload = (e) => {
                const arrayBuffer = e.target.result;
                const binaryStr = new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), '');

                const newFile = {
                    fileContent: binaryStr,
                    name: file.name,
                    customerId: '00000000-0000-0000-0000-000000000000'
                };

                // Opdater state med den nye fil
                this.setState((prevState) => ({
                    pendingFiles: [...prevState.pendingFiles, newFile],
                    loading: false
                }));

                this.props.handleAddUploadedFiles(file.name);
                this.props.handleAddPendingFiles(newFile);
            };

            fileReader.readAsArrayBuffer(file);
        });
    };



    /*     sendFiles = () => {

            const { pendingFiles } = this.state;
            console.log(pendingFiles)

            this.setState({ loading: true });

            pendingFiles.forEach((file) => {
                this.props.uploadFileComplete(file, () => {
                    console.log(`File ${file.name} uploaded successfully.`);
                });
            });

            this.setState({ pendingFiles: [], loading: false });
            this.props.handleResetUploadedFiles();
        }; */
    
    

    render() {
        return (
            <div id={'chat-input-attachment-container'}>
                <input
                    accept="*/*"
                    id="contained-button-file"
                    multiple
                    type="file"
                    style={{ display: "none" }}
                    onChange={this.handleCapture}
                    onClick={(e) => (this.state.loading === false ? (e.target.value = null) : null)}
                    disabled={this.state.loading}
                />
                <label htmlFor="contained-button-file">
                    <Icon
                        tabIndex="4"
                        id={'chat-input-menu-btn'}
                        onClick={this.openMenu}
                        ref={(el) => {
                            this.btnEl = el;
                        }}
                    >
                        <AttachmentICon
                            style={{
                                fill:
                                    this.props.chatConfig &&
                                    this.state.uploadIsHovered === true
                                        ? this.props.chatConfig.inputButtonsFocusedColor
                                        : '#a3a3a8',
                                cursor: this.state.loading ? 'not-allowed' : null,
                            }}
                            onMouseEnter={this.handleUploadHover}
                            onMouseLeave={this.handleUploadHover}
                        />
                    </Icon>
                </label>

            </div>
        );
    }
    
}

export default ChatAttachment;
